import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuth, checkAdmin } from '../../services/auth';

export default function RequireAdmin({ children }){
  const [state, setState] = useState({ loading: true, authed: false, isAdmin: false });

  useEffect(()=>{
    const unsub = onAuth(async (user)=>{
      if (!user) return setState({ loading:false, authed:false, isAdmin:false });
      const ok = await checkAdmin(user.uid);
      setState({ loading:false, authed:true, isAdmin: ok });
    });
    return () => unsub();
  },[]);

  if (state.loading) return <div className="container"><p>Loading…</p></div>;
  if (!state.authed || !state.isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}
